import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';



const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width:'50vw',
    height:'40vw',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};



function TutorialModal(props) {



  return (
    <Container>

      <Modal
        isOpen={props.isTutorialOpen}
        style={customStyles}
        ariaHideApp={false}
        onRequestClose={props.closeTutorial}
        contentLabel="Tutorial Modal"
      >

        <ModalContainer>
            <CloseButton onClick={props.closeTutorial} > X </CloseButton>
            <h2>Tutorial</h2>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/WjY8BznPs10" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

        </ModalContainer>



      </Modal>
    </Container>
  );
}




const Container = styled.div`
    font-family:'Fira Sans';
`;


const ModalContainer = styled.div`
    position:relative;
    display: flex;
    justify-content:space-around;
    flex-direction:column;
    align-items:center;
    height:100%;


`;

const CloseButton = styled.div`
    position: absolute;
    top: 0;
    right:0;
    font-family:'Fira Sans';
    font-size: 30px;
    font-weight: 500;
    &:hover {
     color: #FF0000;
     cursor:pointer;
    }


`;


export default TutorialModal;



// WEBPACK FOOTER //
// ./src/components/tutorialModal.js